module.exports = __webpack_public_path__ + "img/logo_small_height.fe5bed31.png";